export default "__VITE_ASSET__BFpybW39__"